export const selectIsStateZipVerified = (state: ReduxState) => state.businessInfo.isZipStateVerified;
